__turbopack_context__.v({
  "bannerDots": "UfOfEW_bannerDots",
  "dotGrid": "UfOfEW_dotGrid",
});
